import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../api/apiInterceptor";
import {displayNotification} from "./notification";

const initialState = {
    alarmsList: [],
    loading: false,
    pagination: {
        currentPage: 1,
        total: 0,
        pageSize: 0,
    },
    activeAlarms: [],
    activeAlarmsLoading: false,
    activeAlarmsPagination: {
        currentPage: 1,
        total: 0,
        pageSize: 0,
    },
    alarmsConfig: [],
    alarmsConfigLoading: false,
    alarmsConfigPagination: {
        currentPage: 1,
        total: 0,
        pageSize: 0,
    }
}
export const fetchAlarms = createAsyncThunk(
    "fetchAlarms",
    async ({installationId, page = 0}) => {
        const result = await api.get(`/api/installations/${installationId}/alarms?page=${page}`)
        return result.data;
    }
)
export const fetchActiveAlarmsByLocationId = createAsyncThunk(
    "fetchActiveAlarmsByLocation",
    async ({installationId, locationId, page = 0}) => {
        const result = await api.get(`/api/installations/${installationId}/alarms?loc=${locationId}&active=true&page=${page}&onlyReportable=false`)
        return result.data;
    }
)
export const fetchAlarmsByLocationId = createAsyncThunk(
    "fetchAlarmsByLocationId",
    async ({installationId, locationId, page = 0}) => {
        const result = await api.get(`/api/installations/${installationId}/alarms?loc=${locationId}&page=${page}&onlyReportable=false`)
        return result.data;
    }
)
export const fetchAlarmsConfig = createAsyncThunk(
    "fetchAlarmsConfig",
    async ({installationId, locationId, deviceId, page = 0}) => {
        const result = await api.get(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}/alarms?page=${page}`);
        return result.data;
    }
)
export const createAlarmsConfig = createAsyncThunk(
    "createAlarmsConfig",
    async ({installationId, locationId, deviceId, data}, {dispatch}) => {
        await api.post(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}/alarms`, data);
        dispatch(fetchAlarmsConfig({installationId, locationId, deviceId}))
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Alarm uspješno kreiran!",
            title: "Kreiranje alarma!"
        }));
    }
)
export const updateAlarmsConfig = createAsyncThunk(
    "updateAlarmsConfig",
    async ({installationId, locationId, deviceId, alarmId, data}, {dispatch}) => {
        await api.put(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}/alarms/${alarmId}`, data);
        dispatch(fetchAlarmsConfig({installationId, locationId, deviceId}))
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Alarm uspješno ažuriran!",
            title: "Ažirirnaje alarma!"
        }));
    }
)
export const deleteAlarmConfig = createAsyncThunk(
    "deleteAlarmConfig",
    async ({installationId, locationId, deviceId, alarmId}, {dispatch}) => {
        try {
            await api.delete(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}/alarms/${alarmId}`)
            dispatch(fetchAlarmsConfig({installationId, locationId, deviceId}))
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Alarm uspješno obrisan!",
                title: "Brisanje alarma!"
            }));
        } catch (err) {

        }
    }
)
export const cloneAlarms = createAsyncThunk(
    "cloneAlarms",
    async ({installationId, data}, {dispatch}) => {
        await api.post(`/api/installations/${installationId}/clonealarms`, data);
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Alarm uspješno kloniran!",
            title: "Kloniranje alarma!"
        }));
    }
)
export const alarmsSlice = createSlice(
    {
        name: "alarms",
        initialState,
        reducers: {
            clearActiveAlarms: (state) => {
                state.activeAlarms = [];
                state.alarmsList = [];
                state.pagination = initialState.pagination;
                state.activeAlarmsPagination = initialState.activeAlarmsPagination;
                state.activeAlarmsLoading = false;
            }
        },
        extraReducers: builder => {
            builder.addCase(fetchAlarms.pending, state => {
                state.loading = true;
            })
                .addCase(fetchAlarms.fulfilled, (state, action) => {
                    const {content, totalElements, size, number} = action.payload;
                    state.alarmsList = content;
                    state.pagination.total = totalElements;
                    state.pagination.pageSize = size;
                    state.pagination.currentPage = number;
                    state.loading = false;
                })
                .addCase(fetchAlarms.rejected, state => {
                    state.loading = false;
                })
                .addCase(fetchActiveAlarmsByLocationId.pending, state => {
                    state.activeAlarmsLoading = false;
                })
                .addCase(fetchActiveAlarmsByLocationId.fulfilled, (state, action) => {
                    const {content, totalElements, size, number} = action.payload;
                    state.activeAlarms = [...state.activeAlarms, ...content];
                    state.activeAlarmsPagination.total = totalElements;
                    state.activeAlarmsPagination.pageSize = size;
                    state.activeAlarmsPagination.currentPage = number;
                    state.activeAlarmsLoading = false;
                })
                .addCase(fetchActiveAlarmsByLocationId.rejected, state => {
                    state.activeAlarmsLoading = false;
                })
                .addCase(fetchAlarmsConfig.pending, state => {
                    state.alarmsConfigLoading = true;
                })
                .addCase(fetchAlarmsConfig.fulfilled, (state, action) => {
                    const {content, totalElements, size, number} = action.payload;
                    state.alarmsConfigLoading = false;
                    state.alarmsConfig = content;
                    state.alarmsConfigPagination.total = totalElements;
                    state.alarmsConfigPagination.pageSize = size;
                    state.alarmsConfigPagination.currentPage = number;
                })
                .addCase(fetchAlarmsByLocationId.pending, state => {
                    state.loading = true;
                })
                .addCase(fetchAlarmsByLocationId.fulfilled, (state, action) => {
                    const {content, totalElements, size, number} = action.payload;
                    state.alarmsList = content;
                    state.pagination.total = totalElements;
                    state.pagination.pageSize = size;
                    state.pagination.currentPage = number;
                    state.loading = false;
                })
        }
    }
);
export const {clearActiveAlarms} = alarmsSlice.actions;
export default alarmsSlice.reducer;
